module.exports = __webpack_public_path__ + "img/mew-collage-small.c325d801.jpg";